export const INTEGRATED_PRIVACY_POLICY_URL =
  'https://privacy.megazone.com/production/mzc/privacy/index.html';

export const TERMS_OF_SERVICE_URL = 'https://cloudplex.megazone.com/terms/latest';
